<template>
  <div id="pmlst-startup">
    <div class="pmlst-startup-wrapper">
      <div v-if="lead" class="pmlst-startup-lead" v-html="lead"></div>
      <div v-if="button" class="pmlst-startup-button">
        <button class="start" @click.prevent="onStartSelectionTool">
          {{ button }}
        </button>
      </div>
      <div v-if="intro" class="pmlst-startup-intro" v-html="intro"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'start-screen',
  props: {
    startup: {
      type: Object,
      default() {
        return {
          lead: false,
          button: 'Start Selection Tool',
          intro: false
        }
      }
    }
  },
  mounted() {
    this.$on('onStartSelectionTool', () => {
      this.$store.dispatch('setState', 'active')
    })
  },
  computed: {
    button() {
      return this.$props.startup.button
    },
    intro() {
      return this.$props.startup.intro
    },
    lead() {
      return this.$props.startup.lead
    }
  },
  methods: {
    onStartSelectionTool() {
      this.$emit('onStartSelectionTool')
    }
  }
}
</script>
